import React from 'react';
import { motion } from 'framer-motion';
interface CategoryBannerProps {
  src: string;
  alt: string;
  label: string;
}
export function CategoryBanner({
  src,
  alt,
  label
}: CategoryBannerProps) {
  return <motion.figure initial={{
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.75,
    ease: [0.22, 1, 0.36, 1]
  }} className="group relative mb-6 overflow-hidden" data-id="element-403" data-mp="2o5jgjs2jy2oy">
      <motion.div initial={{
      clipPath: 'inset(0 0 100% 0)'
    }} whileInView={{
      clipPath: 'inset(0 0 0% 0)'
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 1.1,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative aspect-[4/5] sm:aspect-[3/4] overflow-hidden bg-dark" data-id="element-404" data-mp="20g8jolobosg3">
        <motion.img src={src} alt={alt} loading="lazy" initial={{
        scale: 1.14
      }} whileInView={{
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 1.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="absolute inset-0 w-full h-full object-cover object-[50%_35%] transition-transform duration-[1200ms] ease-out group-hover:scale-[1.05]" data-id="element-405" data-mp="3gtf9clp03agg" />

        <div aria-hidden className="absolute inset-0 bg-gradient-to-t from-dark/65 via-transparent to-transparent" data-id="element-406" data-mp="1ou3fcbie2och" />

        <span aria-hidden className="pointer-events-none absolute inset-3 border border-warm-white/25 transition-all duration-700 group-hover:inset-2 group-hover:border-warm-white/45" data-id="element-407" data-mp="1eu2siflb9q3j" />

        <motion.figcaption initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        delay: 0.45
      }} className="absolute bottom-0 left-0 right-0 p-6" data-id="element-408" data-mp="1551aykz4b0ng">
          <span className="font-body font-medium text-[10px] tracking-[5px] uppercase text-warm-white/90" data-id="element-409" data-mp="r59tga9e724p">
            {label}
          </span>
        </motion.figcaption>
      </motion.div>
    </motion.figure>;
}
interface ServiceThumbProps {
  src: string;
  alt: string;
}
export function ServiceThumb({
  src,
  alt
}: ServiceThumbProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.94
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className="group/thumb relative w-16 h-20 sm:w-[76px] sm:h-[96px] flex-shrink-0 overflow-hidden bg-cream" data-id="element-410" data-mp="7kt3liu59aw8">
      <img src={src} alt={alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover/thumb:scale-110" data-id="element-411" data-mp="qi2pd6mxz0gn" />
      <span aria-hidden className="pointer-events-none absolute inset-0 border border-gold/40 transition-colors duration-500 group-hover/thumb:border-gold" data-id="element-412" data-mp="1j4x5xsgn1fou" />
      <span aria-hidden className="pointer-events-none absolute inset-0 bg-dark/0 transition-colors duration-500 group-hover/thumb:bg-dark/10" data-id="element-413" data-mp="38mk9lz5j80py" />
    </motion.div>;
}